/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Calendar1 = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M11 14h1v4" }],
    ["path", { d: "M16 2v4" }],
    ["path", { d: "M3 10h18" }],
    ["path", { d: "M8 2v4" }],
    ["rect", { x: "3", y: "4", width: "18", height: "18", rx: "2" }]
  ]
];

export { Calendar1 as default };
//# sourceMappingURL=calendar-1.js.map
